import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { WidgetDef, GENERATE_NOTE } from '../types';
import { DemoHead, DemoSearch, DocList, DocItem } from '../shared';

// spec 621:7907
const ITEMS: (DocItem & { info: string })[] = [
    { title: 'Investor Presentation — August 2026', meta: '14 Aug 2026', info: '24 pages · 2.4 MB', badge: 'Presentation', likes: 18, questions: 2 },
    { title: 'Diggers & Dealers Presentation', meta: '5 Aug 2026', info: '18 pages · 2.4 MB', badge: 'Presentation', likes: 11, questions: 1 },
    { title: 'Investor Presentation — May 2026', meta: '12 May 2026', info: '21 pages · 2.4 MB', badge: 'Presentation', likes: 7, questions: 0 },
    { title: 'Corporate Update — February 2026', meta: '18 Feb 2026', info: '16 pages · 2.4 MB', badge: 'Presentation', likes: 4, questions: 1 },
];

const presentations: WidgetDef = {
    slug: 'presentations',
    name: 'Presentations',
    description: 'Investor and conference presentations',
    icon: <FiFileText />,
    title: 'Presentations Widget',
    installed: true,
    page: '/investors/presentations/',
    views: 620,
    savedCodes: [
        { path: '/investors/investors-dashboard/', note: 'Latest 3' },
        { path: '/investors/presentations/', note: 'Full list' },
    ],
    demoPath: '/investors/presentations/',
    addNote: 'This code is generated from the settings below. Change a setting and the code updates — paste it once, it stays current.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_presentations instance="presentations"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="presentations" data-investi="presentations"></div>', dark: true },
    ],
    settings: [
        { kind: 'heading', label: 'Widget style' },
        { kind: 'segmented', key: 'style', options: ['List', 'Tabs', 'Accordion by year', 'Carousel'], default: 'List' },
        { kind: 'heading', label: 'What visitors can do' },
        { kind: 'toggle', key: 'search', label: 'Search box', hint: 'Search by title', default: true },
        { kind: 'toggle', key: 'filterYear', label: 'Filter by year', default: true },
        { kind: 'heading', label: 'What it shows' },
        { kind: 'toggle', key: 'likes', label: 'Let visitors like a document', hint: 'A like button on every row', default: true },
        { kind: 'toggle', key: 'likeCount', label: 'Show the like count', default: true },
        { kind: 'toggle', key: 'questionCount', label: 'Show the question count', default: true },
        { kind: 'toggle', key: 'questions', label: 'Show the questions section', hint: 'The ask box and published answers', default: true },
        { kind: 'toggle', key: 'fileInfo', label: 'Show the file size and page count', default: true },
        { kind: 'note', text: 'Likes and questions need a signed‑in investor or an email address, so the numbers are real people, not clicks. They appear in Communications › Announcements alongside the announcement.' },
    ],
    generateNote: GENERATE_NOTE,
    Demo: ({ settings: s }) => {
        const items = ITEMS.map(({ info, ...i }) => ({ ...i, meta: s.fileInfo ? `${i.meta} · ${info}` : i.meta }));
        return <>
            <DemoHead title="Presentations" sub="Investor and conference presentations" />
            <DemoSearch placeholder="Search presentations…" showSearch={!!s.search} filters={s.filterYear ? ['Year: All'] : []} />
            <DocList items={items} likes={!!s.likes} likeCount={!!s.likeCount} questionCount={!!s.questionCount} />
        </>;
    },
};

export default presentations;
